export default __webpack_public_path__ + "static/media/02.5d1f74a1.jpg";